import { render, staticRenderFns } from "./intermediaryPlatformOrder.vue?vue&type=template&id=b20cb796&scoped=true"
import script from "./intermediaryPlatformOrder.vue?vue&type=script&lang=js"
export * from "./intermediaryPlatformOrder.vue?vue&type=script&lang=js"
import style0 from "./intermediaryPlatformOrder.vue?vue&type=style&index=0&id=b20cb796&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b20cb796",
  null
  
)

export default component.exports